import React, { useCallback, useEffect } from 'react'
import Modal from 'src/components/shared/Modal'
import { cfosDisclousuresV2 } from 'src/components/layouts/consts'

const Qualify = ({
  data,
  handleClick,
  getUrl,
  showModal,
  modalScrollTarget,
  onModalOpen,
  onModalClose,
}) => {
  const { amountDescription, buttonText } = data

  const handleModalOpen = useCallback(() => {
    onModalOpen(null)
  }, [onModalOpen])

  const handleModalClose = useCallback(() => {
    onModalClose()
  }, [onModalClose])

  useEffect(() => {
    if (showModal && modalScrollTarget) {
      const timer = setTimeout(() => {
        const el = document.getElementById(modalScrollTarget)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100)

      return () => clearTimeout(timer)
    }
  }, [showModal, modalScrollTarget])

  return (
    <>
      <div className="rounded-lg bg-secondary p-4 text-center lg:p-6">
        <p className="text-center text-heading-3.5 font-bold leading-[120%] text-content-primary lg:text-2xl lg:leading-[130%]">
          {amountDescription}
        </p>
        <div className="mx-auto mt-2 flex h-12 w-full max-w-[303px] cursor-pointer items-center justify-center rounded-lg bg-blue-585 px-6 py-2 text-center lg:mt-4">
          <a onClick={handleClick} href={getUrl()} className="   ">
            <span className="text-lg font-bold leading-[120%] tracking-[0.36px] text-[#F9F9F9]">
              {buttonText}
            </span>
          </a>
        </div>
      </div>
      <div className="mt-4 w-full text-center lg:mt-5">
        <a
          onClick={handleModalOpen}
          className="cursor-pointer text-center text-base font-normal leading-[140%] text-content-secondary underline decoration-solid underline-offset-auto"
        >
          How are these numbers calculated?
        </a>
        {showModal && (
          <Modal
            bodyClassName="mb-4 mt-9 "
            onClose={handleModalClose}
            open={showModal}
            className="w-100 max-w-[450px] lg:w-[30%]"
            hasDistanceFromTop={true}
          >
            <div className="p-5">
              <span className="text-heading-2 font-bold">
                How are these numbers calculated?
              </span>
              <div className="my-5 text-left text-14 text-gray-500">
                {cfosDisclousuresV2
                  .trim()
                  .split('\n\n')
                  .map((paragraph, index) => {
                    let id
                    if (paragraph.startsWith('Information*'))
                      id = 'disclosure-star'
                    else if (
                      paragraph.startsWith(
                        'Estimated current total minimum monthly payment**'
                      )
                    )
                      id = 'disclosure-double-star'

                    return (
                      <p key={index} id={id} className="mb-4">
                        {paragraph}
                      </p>
                    )
                  })}
              </div>
              <div className="flex justify-end">
                <a
                  onClick={handleModalClose}
                  className="group flex w-full items-center justify-center gap-x-3 rounded-lg bg-blue-560 p-3 lg:w-fit"
                >
                  <span className="whitespace-nowrap text-lg font-bold text-white">
                    Go back
                  </span>
                </a>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </>
  )
}

export default Qualify
